import React, { useEffect, useRef, useState } from 'react'

import clsx from 'clsx'

import Link from 'components/Link'
import { useEventContext } from 'context/EventContext'

import classes from './CollapsibleContent.module.scss'

/** @type {import("./types").default} */
const CollapsibleContent = ({ className, expanded, onChange, maxHeight = 150, showText = 'Read more', children }) => {
  const [hasOverflow, setHasOverflow] = useState(true)
  const ref = useRef()
  const eventContext = useEventContext({
    engagementComponent: 'collapsible-content',
    engagementDetails: 'read-more',
  })

  useEffect(() => {
    setHasOverflow(
      ref.current.getBoundingClientRect().height > ref.current.parentElement.getBoundingClientRect().height
    )
  }, [ref, children])

  return (
    <div
      className={clsx('CollapsibleContent', classes.root, className, { [classes.expanded]: expanded })}
      style={{ maxHeight: expanded ? 'unset' : maxHeight }}
    >
      <div ref={ref} className={classes.content}>
        {children}
      </div>
      {(hasOverflow || expanded) && (
        <div className={classes.readMore}>
          <Link
            variant="button-sm"
            className={classes.showMoreButton}
            {...eventContext.addEvent({
              engagementDestination: expanded ? 'collapse' : 'expand',
              name: 'engagement_product_click',
            })}
            onClick={() => onChange(!expanded)}
          >
            {showText}
          </Link>
        </div>
      )}
    </div>
  )
}

export default CollapsibleContent
